<div
  class="flex flex-col h-screen bg-gradient-to-br from-sacred/10 to-white dark:from-stone-900/20 dark:to-stone-800/50 text-rooted dark:text-stone-200 relative overflow-hidden">
  <!-- Sacred Floating Orbs -->
  <div
    class="absolute top-20 left-20 w-40 h-40 bg-bloom/10 dark:bg-fuchsia-500/8 rounded-full blur-3xl animate-pulse pointer-events-none">
  </div>
  <div
    class="absolute bottom-20 right-20 w-32 h-32 bg-soulfire/8 dark:bg-fuchsia-600/6 rounded-full blur-3xl animate-pulse pointer-events-none">
  </div>
  <div
    class="absolute top-1/2 right-10 w-24 h-24 bg-bloom/8 dark:bg-fuchsia-400/6 rounded-full blur-2xl animate-pulse pointer-events-none">
  </div>

  <!-- Fixed Sacred Header -->
  <div class="fixed top-0 left-0 right-0 z-50 h-14 sm:h-16">
    <header-layout></header-layout>
  </div>

  <!-- Sacred Content below header -->
  <div class="flex flex-1 pt-14 sm:pt-16 overflow-hidden relative z-10">
    <!-- Sacred Sidebar — visible only on sm+ screens -->
    <div class="hidden sm:flex h-full">
      <sidebar-layout></sidebar-layout>
    </div>

    <!-- Sacred Main Content -->
    <main class="flex-1 overflow-auto relative flex flex-col">
      <!-- Page Content -->
      <div class="flex-1 p-4 sm:p-6 lg:p-8 pb-20 sm:pb-6 lg:pb-8 relative z-10">
        <router-outlet></router-outlet>
      </div>

      <!-- Sacred Gradient Overlay for depth -->
      <!-- <div
        class="absolute inset-0 bg-gradient-to-t from-white/20 via-transparent to-transparent dark:from-stone-800/30 dark:!via-transparent dark:!to-stone-800/30 pointer-events-none"
      ></div> -->
    </main>
  </div>

  <!-- Mobile Bottom Navigation (hidden on sm+) -->
  <bottom-nav></bottom-nav>
</div>